import React from 'react';
import { ResearcherEvaluation } from '../../types';
import styles from './EvaluationInfoTable.module.css';

interface EvaluationInfoTableProps {
  evaluation: ResearcherEvaluation;
  finalScore?: number;
  showEvaluatorInfo?: boolean;
  evaluatorName?: string;
  isExternal?: boolean;
  assignedAt?: string;
}

const EvaluationInfoTable: React.FC<EvaluationInfoTableProps> = ({
  evaluation,
  finalScore,
  showEvaluatorInfo = false,
  evaluatorName,
  isExternal,
  assignedAt,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('es-CL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={styles.summarySection}>
      <h2>Información de la Evaluación</h2>
      <div className={styles.infoTable}>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Estado:</span>
          <span className={styles.infoValue}>
            {evaluation.submittedAt ? (
              <span className={styles.statusSubmitted}>Enviada el {formatDate(evaluation.submittedAt)}</span>
            ) : (
              <span className={styles.statusPending}>Pendiente</span>
            )}
          </span>
        </div>

        {finalScore !== undefined && (
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Puntaje Final:</span>
            <span className={styles.infoValue}>
              <span className={styles.finalScore}>{finalScore.toFixed(2)}</span>
              <span className={styles.finalScoreMax}> / 5.00</span>
            </span>
          </div>
        )}

        {showEvaluatorInfo && evaluatorName && (
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Evaluador:</span>
            <span className={styles.infoValue}>
              {evaluatorName} ({isExternal ? 'Externo' : 'UC'})
            </span>
          </div>
        )}

        {showEvaluatorInfo && assignedAt && (
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Asignado:</span>
            <span className={styles.infoValue}>{formatDate(assignedAt)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvaluationInfoTable;